var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"contents"}},[_vm._t("default",null,{"entry":_vm.entry})],2)}
var staticRenderFns = []

export { render, staticRenderFns }